import getCalendarEventData from './getCalendarEventData';
import getViewState from './getViewState';

export function shouldShowWorkingHours(viewStateId: string) {
    const eventData = getCalendarEventData(viewStateId);

    return getViewState(viewStateId).showWorkingHoursOnly && eventData.Start.tz == eventData.End.tz;
}
